import { ReactElement } from 'react';
import { Layout } from '../../../components/layout/Layout';
import Header from '../../../components/header/Header';
import Content from './Content';

const CallRequestPage = (): ReactElement => {
  return <Layout header={<Header />} content={<Content />} />;
};

export default CallRequestPage;
